
export const adjustMapping = {'304' : Adjust304 , 'Monel' : AdjustMonel, 'Bronze' : AdjustBronze, 'Inconel 625' : AdjustInconel625, 'Hastelloy C276' : AdjustHastelloyC276 }

export function Adjust304(temperature) {
    var adjustFactor = 1;
    if (temperature > 1500) {
        return -1;
    } else if (temperature >= 90 && temperature < 125) {
        adjustFactor = 0.99;
    } else if (temperature >= 125 && temperature < 150) {
        adjustFactor = 0.97;
    } else if (temperature >= 150 && temperature < 175) {
        adjustFactor = 0.95;
    } else if (temperature >= 175 && temperature < 200) {
        adjustFactor = 0.93;
    } else if (temperature >= 200 && temperature < 225) {
        adjustFactor = 0.91;
    } else if (temperature >= 225 && temperature < 250) {
        adjustFactor = 0.88;
    } else if (temperature >= 250 && temperature < 300) {
        adjustFactor = 0.88;
    } else if (temperature >= 300 && temperature < 350) {
        adjustFactor = 0.85;
    } else if (temperature >= 350 && temperature < 400) {
        adjustFactor = 0.81;
    } else if (temperature >= 400 && temperature < 450) {
        adjustFactor = 0.78;
    } else if (temperature >= 450 && temperature < 600) {
        adjustFactor = 0.77;
    } else if (temperature >= 600 && temperature < 700) {
        adjustFactor = 0.76;
    } else if (temperature >= 700 && temperature < 800) {
        adjustFactor = 0.74;
    } else if (temperature >= 800 && temperature < 900) {
        adjustFactor = 0.73;
    } else if (temperature >= 900 && temperature < 1000) {
        adjustFactor = 0.68;
    } else if (temperature >= 1000 && temperature < 1100) {
        adjustFactor = 0.60;
    } else if (temperature >= 1100 && temperature < 1200) {
        adjustFactor = 0.58;
    } else if (temperature >= 1200 && temperature < 1300) {
        adjustFactor = 0.53;
    } else if (temperature >= 1300 && temperature < 1400) {
        adjustFactor = 0.44;
    } else if (temperature >= 1400 && temperature < 1500) {
        adjustFactor = 0.35;
    } else if (temperature === 1500) {
        adjustFactor = 0.26;
    }
    return adjustFactor

};

export function AdjustMonel(temperature) {
    var adjustFactor = 1;

    if (temperature > 800) {
        return -1;
    } else if (temperature >= 90 && temperature < 125) {
        adjustFactor = 0.95;
    } else if (temperature >= 125 && temperature < 150) {
        adjustFactor = 0.94;
    } else if (temperature >= 150 && temperature < 175) {
        adjustFactor = 0.93;
    } else if (temperature >= 175 && temperature < 200) {
        adjustFactor = 0.91;
    } else if (temperature >= 200 && temperature < 225) {
        adjustFactor = 0.90;
    } else if (temperature >= 225 && temperature < 250) {
        adjustFactor = 0.88;
    } else if (temperature >= 250 && temperature < 300) {
        adjustFactor = 0.87;
    } else if (temperature >= 300 && temperature < 350) {
        adjustFactor = 0.83;
    } else if (temperature >= 350 && temperature < 400) {
        adjustFactor = 0.82;
    } else if (temperature >= 400 && temperature < 450) {
        adjustFactor = 0.79;
    } else if (temperature >= 450 && temperature < 500) {
        adjustFactor = 0.77;
    } else if (temperature >= 500 && temperature < 600) {
        adjustFactor = 0.73;
    } else if (temperature >= 600 && temperature < 700) {
        adjustFactor = 0.72;
    } else if (temperature >= 700 && temperature < 800) {
        adjustFactor = 0.71;
    } else if (temperature === 800) {
        adjustFactor = 0.70;
    }
    return adjustFactor;

};

export function AdjustBronze(temperature) {
    var adjustFactor = 1;

    if (temperature > 450) {
        return -1;
    } else if (temperature >= 90 && temperature < 125) {
        adjustFactor = 0.93;
    } else if (temperature >= 125 && temperature < 150) {
        adjustFactor = 0.92;
    } else if (temperature >= 150 && temperature < 175) {
        adjustFactor = 0.92;
    } else if (temperature >= 175 && temperature < 200) {
        adjustFactor = 0.90;
    } else if (temperature >= 200 && temperature < 225) {
        adjustFactor = 0.89;
    } else if (temperature >= 225 && temperature < 250) {
        adjustFactor = 0.86;
    } else if (temperature >= 250 && temperature < 300) {
        adjustFactor = 0.86;
    } else if (temperature >= 300 && temperature < 350) {
        adjustFactor = 0.83;
    } else if (temperature >= 350 && temperature < 400) {
        adjustFactor = 0.81;
    } else if (temperature >= 400 && temperature < 450) {
        adjustFactor = 0.78;
    } else if (temperature === 450) {
        adjustFactor = 0.75;
    }
  
    
    return adjustFactor;

};

export function AdjustInconel625(temperature) {
    var adjustFactor = 1;

    if (temperature > 1800) {
        return -1;
        } else if (temperature >= 70 && temperature < 200) {
            adjustFactor = 1;
    } else if (temperature >= 200 && temperature < 300) {
            adjustFactor = 0.96;
    } else if (temperature >= 300 && temperature < 400) {
            adjustFactor = 0.94;
    } else if (temperature >= 400 && temperature < 500) {
            adjustFactor = 0.93;
    } else if (temperature >= 500 && temperature < 600) {
            adjustFactor = 0.93;
    } else if (temperature >= 600 && temperature < 650) {
            adjustFactor = 0.93;
    } else if (temperature >= 650 && temperature < 700) {
            adjustFactor = 0.93;
    } else if (temperature >= 700 && temperature < 750) {
            adjustFactor = 0.93;
    } else if (temperature >= 750 && temperature < 800) {
            adjustFactor = 0.93;
    } else if (temperature >= 800 && temperature < 850) {
            adjustFactor = 0.93;
    } else if (temperature >= 850 && temperature < 900) {
            adjustFactor = 0.93;
    } else if (temperature >= 900 && temperature < 950) {
            adjustFactor = 0.93;
    } else if (temperature >= 950 && temperature < 1000) {
            adjustFactor = 0.93;
    } else if (temperature >= 1000 && temperature < 1050) {
            adjustFactor = 0.93;
    } else if (temperature >= 1050 && temperature < 1100) {
            adjustFactor = 0.93;
    } else if (temperature >= 1100 && temperature < 1150) {
            adjustFactor = 0.9;
    } else if (temperature >= 1150 && temperature < 1200) {
            adjustFactor = 0.87;
    } else if (temperature >= 1200 && temperature < 1250) {
            adjustFactor = 0.84;
    } else if (temperature >= 1250 && temperature < 1300) {
            adjustFactor = 0.77;
    } else if (temperature >= 1300 && temperature < 1400) {
            adjustFactor = 0.7;
    } else if (temperature >= 1400 && temperature < 1500) {
            adjustFactor = 0.57;
    } else if (temperature >= 1500 && temperature < 1600) {
            adjustFactor = 0.5;
    } else if (temperature >= 1600 && temperature < 1800) {
            adjustFactor = 0.3;
    } else if (temperature === 1800 ) {
            adjustFactor = 0.14;
    
    }
  
    
    return adjustFactor;

};

export function AdjustHastelloyC276(temperature) {
    var adjustFactor = 1;

    if (temperature > 800) {
        return -1;
        } else if (temperature >= 70 && temperature < 200) {
            adjustFactor = 1;
    } else if (temperature >= 200 && temperature < 300) {
            adjustFactor = 1;
    } else if (temperature >= 300 && temperature < 400) {
            adjustFactor = 1;
    } else if (temperature >= 400 && temperature < 500) {
            adjustFactor = 1;
    } else if (temperature >= 500 && temperature < 600) {
            adjustFactor = 0.99;
    } else if (temperature >= 600 && temperature < 650) {
            adjustFactor = 0.92;
    } else if (temperature >= 650 && temperature < 700) {
            adjustFactor = 0.9;
    } else if (temperature >= 700 && temperature < 750) {
            adjustFactor = 0.88;
    } else if (temperature >= 750 && temperature < 800) {
            adjustFactor = 0.86;
    } else if (temperature >= 800 && temperature < 850) {
            adjustFactor = 0.85;
    } else if (temperature >= 850 && temperature < 900) {
            adjustFactor = 0.84;
    } else if (temperature >= 900 && temperature < 950) {
            adjustFactor = 0.83;
    } else if (temperature >= 950 && temperature < 1000) {
            adjustFactor = 0.82;
    } else if (temperature >= 1000 && temperature < 1050) {
            adjustFactor = 0.82;
    } else if (temperature >= 1050 && temperature < 1100) {
            adjustFactor = 0.68;
    } else if (temperature >= 1100 && temperature < 1150) {
            adjustFactor = 0.55;
    } else if (temperature >= 1150 && temperature < 1200) {
            adjustFactor = 0.45;
    } else if (temperature >= 1200 && temperature < 1250) {
            adjustFactor = 0.36;
    } else if (temperature === 1250) {
            adjustFactor = 0.29;
    
    }
  
    
    return adjustFactor;

};
